import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { baseConfig } from "./dataLayer";
var RegexType = /$/;
var PLACEHOLDER_VAR = "%s";
var getRoutes = function(settings) {
    var config = _object_spread({}, baseConfig, settings);
    var routes = [
        {
            path: "/",
            lang: "de",
            tracking: _object_spread_props(_object_spread({}, config), {
                virtPath: "/cars/bm/Index",
                landingpageKategorie: "",
                websitebereich: "Startseite, Mietwagen-Suche",
                englishPageName: "d/funnel/index",
                landingPageType: "index"
            })
        },
        {
            path: "/vermieter-bewertung.html",
            lang: "de",
            tracking: _object_spread_props(_object_spread({}, config), {
                virtPath: "/vermieter-bewertung.html",
                landingpageKategorie: "",
                websitebereich: "Content-Seite",
                englishPageName: "d/seo/partnerlist",
                landingPageType: "index"
            })
        },
        {
            path: "/mietwagen-flughafen.html",
            lang: "de",
            tracking: _object_spread_props(_object_spread({}, config), {
                virtPath: "/mietwagen-flughafen.html",
                landingpageKategorie: "",
                websitebereich: "Content-Seite",
                englishPageName: "d/seo/mietwagen/flughafen",
                landingPageType: "index"
            })
        },
        {
            path: "/mietwagen-bahnhof.html",
            lang: "de",
            tracking: _object_spread_props(_object_spread({}, config), {
                virtPath: "/mietwagen-bahnhof.html",
                landingpageKategorie: "",
                websitebereich: "Content-Seite",
                englishPageName: "d/seo/mietwagen/bahnhof",
                landingPageType: "index"
            })
        },
        {
            path: "/mietwagen.htm",
            lang: "de",
            tracking: _object_spread_props(_object_spread({}, config), {
                virtPath: "/mietwagen.htm",
                landingpageKategorie: "",
                websitebereich: "Content-Seite",
                englishPageName: "d/seo/weltweit",
                landingPageType: "index"
            })
        },
        {
            path: "/mietwagen-bewertung.html",
            lang: "de",
            tracking: _object_spread_props(_object_spread({}, config), {
                virtPath: "/mietwagen-bewertung.html",
                landingpageKategorie: "",
                websitebereich: "Content-Seite",
                englishPageName: "d/seo/feedbacklist/",
                landingPageType: "index"
            })
        },
        {
            // regex, e.g. autovermieter-avis.html
            path: /\/(autovermieter-(.*))\.html/,
            lang: "de",
            tracking: _object_spread_props(_object_spread({}, config), {
                virtPath: "/partner-".concat(PLACEHOLDER_VAR, ".html"),
                landingpageKategorie: PLACEHOLDER_VAR,
                websitebereich: "Landingpage, Mietwagen-Suche",
                englishPageName: "d/seo/partner-".concat(PLACEHOLDER_VAR),
                landingPageType: "seo"
            })
        },
        {
            // regex, e.g. mietwagen-muenchen.html
            path: /\/(mietwagen-(.*))\.html/,
            lang: "de",
            tracking: _object_spread_props(_object_spread({}, config), {
                virtPath: "/mietwagen-".concat(PLACEHOLDER_VAR, ".html"),
                landingpageKategorie: PLACEHOLDER_VAR,
                websitebereich: "Landingpage, Mietwagen-Suche",
                englishPageName: "d/seo/mietwagen/".concat(PLACEHOLDER_VAR),
                landingPageType: "seo"
            })
        },
        {
            // regex, e.g. autovermietung-berlin.html
            path: /\/(autovermietung-(.*))\.html/,
            lang: "de",
            tracking: _object_spread_props(_object_spread({}, config), {
                virtPath: "/autovermietung-".concat(PLACEHOLDER_VAR, ".html"),
                landingpageKategorie: PLACEHOLDER_VAR,
                websitebereich: "Landingpage, Mietwagen-Suche",
                englishPageName: "d/seo/mietwagen/".concat(PLACEHOLDER_VAR),
                landingPageType: "seo"
            })
        },
        {
            // regex, e.g. rentacar-lax.html
            path: /\/(rentacar-(.*))\.html/,
            lang: "de",
            tracking: _object_spread_props(_object_spread({}, config), {
                virtPath: "/rentacar-".concat(PLACEHOLDER_VAR, ".html"),
                landingpageKategorie: PLACEHOLDER_VAR,
                websitebereich: "Landingpage, Mietwagen-Suche",
                englishPageName: "d/seo/rentacar/".concat(PLACEHOLDER_VAR),
                landingPageType: "seo"
            })
        },
        {
            path: "/monde.html",
            lang: "fr",
            tracking: _object_spread_props(_object_spread({}, config), {
                virtPath: "/monde.html",
                landingpageKategorie: "",
                websitebereich: "Content-Seite",
                englishPageName: "d/seo/weltweit",
                landingPageType: "index"
            })
        },
        {
            path: "/avis-client.html",
            lang: "fr",
            tracking: _object_spread_props(_object_spread({}, config), {
                virtPath: "/avis-client.html",
                landingpageKategorie: "",
                websitebereich: "Content-Seite",
                englishPageName: "d/seo/feedbacklist/",
                landingPageType: "index"
            })
        },
        {
            path: "/avis-par-loueur.html",
            lang: "fr",
            tracking: _object_spread_props(_object_spread({}, config), {
                virtPath: "/avis-par-loueur.html",
                landingpageKategorie: "",
                websitebereich: "Content-Seite",
                englishPageName: "d/seo/partnerlist",
                landingPageType: "index"
            })
        },
        {
            path: "/location-voiture-aeroport.html",
            lang: "fr",
            tracking: _object_spread_props(_object_spread({}, config), {
                virtPath: "/location-voiture-aeroport.html",
                landingpageKategorie: "",
                websitebereich: "Content-Seite",
                englishPageName: "d/seo/mietwagen/flughafen",
                landingPageType: "index"
            })
        },
        {
            path: "/location-voiture-gare.html",
            lang: "fr",
            tracking: _object_spread_props(_object_spread({}, config), {
                virtPath: "/location-voiture-gare.html",
                landingpageKategorie: "",
                websitebereich: "Content-Seite",
                englishPageName: "d/seo/mietwagen/bahnhof",
                landingPageType: "index"
            })
        },
        {
            // regex, e.g. loueur-jucy-rentals.html
            path: /\/(loueur-(.*))\.html/,
            lang: "fr",
            tracking: _object_spread_props(_object_spread({}, config), {
                virtPath: "/partenaire-".concat(PLACEHOLDER_VAR, ".html"),
                landingpageKategorie: PLACEHOLDER_VAR,
                websitebereich: "Landingpage, Mietwagen-Suche",
                englishPageName: "d/seo/partenaire-".concat(PLACEHOLDER_VAR),
                landingPageType: "seo"
            })
        },
        {
            // regex, e.g. louer-gare-lille.html
            path: /\/(louer-(.*))\.html/,
            lang: "fr",
            tracking: _object_spread_props(_object_spread({}, config), {
                virtPath: "/location-voiture-".concat(PLACEHOLDER_VAR, ".html"),
                landingpageKategorie: PLACEHOLDER_VAR,
                websitebereich: "Landingpage, Mietwagen-Suche",
                englishPageName: "d/seo/location-voiture-".concat(PLACEHOLDER_VAR),
                landingPageType: "seo"
            })
        },
        {
            // regex, e.g. /alquiler-coche/espana/navarra
            path: /\/(alquiler-coche\/(.*))/,
            lang: "es",
            tracking: _object_spread_props(_object_spread({}, config), {
                virtPath: "/alquiler-coche/".concat(PLACEHOLDER_VAR),
                landingpageKategorie: PLACEHOLDER_VAR,
                websitebereich: "Landingpage, Mietwagen-Suche",
                englishPageName: "d/seo/alquiler-coche/".concat(PLACEHOLDER_VAR),
                landingPageType: "seo"
            })
        }, 
    ];
    return routes;
};
export { getRoutes, RegexType, PLACEHOLDER_VAR };
